import styled from 'styled-components';

export const SearchNone = styled.div`
  margin: 1rem;
  padding: 15% 0;
  text-align: center;
  color: ${({ theme }) => theme.color.textPrime};
  font-size: 1.1rem;
`;
